import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Camera, Star } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 grid-pattern opacity-50" />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black" />
      
      {/* Accent Glow */}
      <div className="absolute top-1/4 -right-32 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 -left-32 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-gray-800/50 border border-gray-700 rounded-full px-4 py-2 mb-8 animate-fade-in-up">
            <Star className="w-4 h-4 text-cyan-400" />
            <span className="text-gray-300 text-sm font-medium">Serving {businessInfo.serviceArea}</span>
          </div>

          {/* Main Heading */}
          <h1 className="hero-title text-white mb-6 animate-fade-in-up delay-100">
            Capture Every
            <span className="block text-cyan-400">Moment</span>
          </h1>

          {/* Subtitle */}
          <p className="subtitle max-w-2xl mx-auto mb-10 animate-fade-in-up delay-200">
            Premium photo booth rentals for weddings, corporate events, and celebrations.
            All-day rentals with unlimited photos and instant digital sharing.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 animate-fade-in-up delay-300">
            <Button
              onClick={() => scrollToSection('#packages')}
              className="bg-cyan-500 hover:bg-cyan-600 text-black font-semibold px-8 py-6 text-lg group"
            >
              View Packages
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => scrollToSection('#gallery')}
              variant="outline"
              className="border-gray-600 text-white hover:bg-white hover:text-black px-8 py-6 text-lg"
            >
              See Our Work
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto animate-fade-in-up delay-400">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-white font-display">500+</div>
              <div className="text-gray-500 text-sm mt-1">Events</div>
            </div>
            <div className="text-center border-x border-gray-800">
              <div className="text-3xl sm:text-4xl font-bold text-white font-display">50K+</div>
              <div className="text-gray-500 text-sm mt-1">Photos</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-white font-display">5</div>
              <div className="text-gray-500 text-sm mt-1 flex items-center justify-center">
                <Star className="w-3 h-3 text-cyan-400 mr-1" /> Rating
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-gray-600 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-cyan-400 rounded-full mt-2 animate-pulse" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
